import {useEffect, useState} from 'react';

const BASE = process.env.REACT_APP_AWP_API_URL || 'https://awp.minsky.ai';
function _authH() { const t = localStorage.getItem('access_token'); return t ? {'Authorization': `Bearer ${t}`} : {}; }

const useReadbookItems = (readbookId) => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!readbookId) { setItems([]); setLoading(false); return; }
        fetch(`${BASE}/api/readbooks/${encodeURIComponent(readbookId)}/items`, {headers: _authH()})
            .then(r => r.ok ? r.json() : [])
            .then(data => { setItems(Array.isArray(data) ? data : []); setLoading(false); })
            .catch(err => { setError(err); setLoading(false); });
    }, [readbookId]);

    return {items, loading, error};
};

export default useReadbookItems;
